import React from 'react';
import './customStyles.css';

export const checkboxComponent = ({
  field,
  form: { touched, errors },
  ...props
}) => {
  return (
    <div className="c-checkbox-container">
      <label className="c-checkbox" 
            onClick={props.onClick}>
          <input
            className="c-checkbox__input"
            type="checkbox"
            name={props.name}
            id={props.id}
            onChange={() => {}}
            checked={props.isChecked? true : false}
            alt={props.helpText}
            value={props.value}
            data-test-id={props.dataTestId}
          />
          <span className="c-checkbox__label">{props.checkboxText}</span>
      </label>
    </div>
  )
}

export const radiosComponent = ({
  field,
  form: { touched, errors },
  ...props
}) => {

  return (
    <div className="c-radio-container">
      <label className="c-radio">
        <input
          className="c-radio__input"
          type="radio"
          id={props.id}
          name={props.customName}
          checked={props.isChecked ? true : false}
          onClick={props.onClick}
          onChange={() => {}}
          value={props.value}
          data-test-id={props.dataTestId}
          disabled={props.disabled || false}
        />
        <span className="c-radio__label">
          {props.radioText}
        </span>
      </label>
    </div>
  )
}
